import React from "react";

const Theme = () => {
  return (
    <div className="columns">
      <div className="column">
        <div>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/b/b/b/0/bbb0a8963e9ed3b81974613b52b9476c.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>cà phê</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/d/0/d/7/d0d772a6c3e35b3e768d5c3ebf644ecd.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>spa-yoga</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="column">
        <div>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/0/f/d/1/0fd1da7445b21a752a1c4282b06f2cf0.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>thư giãn</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/e/3/d/4/e3d43659c6dc756f87f4e44220313f92.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>du lịch</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="column">
        <div>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/4/a/3/b/4a3b5265ee2c9e2c84f5a88194382b5d.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>ngủ ngon</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/b/1/e/b/b1eb8ae84392957f9b9d1ce2bb42aab9.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>tập trung</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="column">
        <div>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/e/6/8/0/e680570f74b3497c95d96f6ba6db7b07.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>giai điệu buồn</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="">
            <div className="topic-item">
              <figure>
                <img
                  className="image-topic"
                  src="https://photo-zmp3.zmdcdn.me/cover/8/5/d/1/85d1cfedf63d33e676e85071ab023f66.jpg"
                  alt=""
                />
              </figure>
              <div className="topic-info">
                <div className="topic-title">
                  <h3>running</h3>
                </div>
                <div className="thumbnail__images">
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/8/e/b/9/8eb9473469852ffe7d6bfb41c699f7b7.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/f/9/a/2/f9a2aa0e114eb9c3b7aa71f970797d1b.jpg"
                      alt=""
                    />
                  </div>
                  <div className="thumbnail__image">
                    <img
                      src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/6/2/1/c621b2dee0d737b233b6b805ed944552.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Theme;
